export const enum IceHockeyKeyPeriod {
  FINISHED = 'finished',
  TIME_BREAK_PERIOD = 'timeBreakPeriod',
  TIME_BREAK = 'timeBreak',
  TIMEOUT = 'timeout',
  OVERTIME = 'overtime',
  BULLET = 'bullet',
  PERIOD = 'period',
}
